export default {
    label_task:{
        en:"Type Calendar",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Type Calendar",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Type Calendar",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Type Calendar",
        bn:'ব্যবহারকারীর বিবরণ'
    },


}